import { NgModule, DoBootstrap, ApplicationRef } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { take, filter } from 'rxjs/operators';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { ApiService } from 'src/app/shared/services/api.service';
import { AppService } from 'src/app/shared/services/app.service';
import { environment } from 'src/environments/environment';
import { DebugService } from 'src/app/shared/services/debug.service';
import { SpokeGuard } from './shared/guards/spoke.guard';
import { UserGuard } from './shared/guards/user.guard';
import { UserAdministratorGuard } from './shared/guards/user-administrator.guard';
import { TableAdministratorGuard } from './shared/guards/table-administrator.guard';
import { SystemAdministratorGuard } from './shared/guards/system-administrator.guard';
import { NotifyService } from '@services/notify.service';


@NgModule({
	declarations: [
		AppComponent,
	],
	imports: [
		BrowserAnimationsModule, // do not redeclare this in any submodule!
		BrowserModule, // do not redeclare this in any submodule!
		// HttpClientModule //  do not redeclare this in any submodule! // would get loaded if here if you need to make external calls
		SharedModule,
		AppRoutingModule,
	],
	providers: [
		// global singleton instances of services should be provided here
		// if you declare them in your own module, and need access elsewhere,
		// they will each have their own instance and will not talk to one another
		ApiService,
		AppService,
		DebugService,
		NotifyService,

		// Guards
		SystemAdministratorGuard,
		TableAdministratorGuard,
		UserAdministratorGuard,
		UserGuard,
		SpokeGuard, // ensure you include {spoke: string} in route.data
	]
})
export class AppModule implements DoBootstrap {
	constructor(
		private _app: AppService,
		debug: DebugService,
	) {
		debug.__bootstrap();

		console.warn('deprecation notice\n\nthe socket.service has been removed, as the feature is now being handled by auxilium-connect api version.  use `apiService.socket` instead!\n\n');
		console.warn('ALERT *************************\n\nplease ensure you disconnect the old repository `rm -rf ./.git` before committing to\n\n');
	}

	ngDoBootstrap(app: ApplicationRef) {
		const api = environment.api;
		if (api && api.autoAuthenticate) {
			this._app.auth
				.pipe(
					filter(a => !!a),
					take(1)
				)
				.subscribe(() => app.bootstrap(AppComponent));
		} else {
			app.bootstrap(AppComponent);
		}
	}
}
